export default __webpack_public_path__ + "static/media/atopic-dermatitisp.4b2cda83.pdf";